export const Cookie = {
    BCAI_EMAIL: '_bcai_el',
    BCAI_PLATFORM: '_bcai_pl',
    SIDEBAR_STATE: 'sidebar_state',
}

export const LocalStorageKey = {
    BANNER_DISMISSED_KEY: 'data_backdated_banner_dismissed',
    BCAI_CALL_BOOKED: '_bcai_ocb',
    CLIENT_HASH: 'clientHash',
    JWT: 'jwt',
    LANDING_PAGE_CACHE_PREFIX: 'LANDING_PAGE',
    LANDING_PAGE_LINK_CACHE_PREFIX: 'LANDING_PAGE_LINK',
    METRICS_CACHE_PREFIX: 'storefront_metrics',
    SELECTED_METRIC: 'selectedMetric',
    STAGED_CONTENT_CACHE_PREFIX: 'STAGED_CONTENT',
    VERIFYING_TOKEN_KEY: 'isVerifyingMagicLink',
    MULTI_STOREFRONT_OPTIN_SHOWN: 'multi_storefront_optin_shown',
}

export const SessionStorageKey = {
    FROM_SIGNUP: 'fromSignup',
}
